<template>
  <el-dialog :visible="true" :show-close="false" :top="windowTop">
    <slot v-if="componentName === 'slot'"></slot>
    <component
      :is="componentName"
      @close="$emit('close')" 
      :solutionId="detailId"
      :contentTitle="solutionTitle"
    ></component>
  </el-dialog>
</template>

<script>
import cooperationRegister from "@/views/cooperation-register.vue";
import complaint from "@/views/complaint.vue";
import coupon from "@/views/coupon.vue";
import noDisplay from "@/views/no-display.vue";
import solution from "@/views/solution-detail.vue";
import yunClass from "@/views/yunClass-detail.vue";
export default {
  name: "pageMask",
  components: {
    cooperationRegister,
    complaint,
    noDisplay,
    solution,
    coupon,
    yunClass
  },
  props: {
    componentName: {
      type: String,
      default: ""
    },
    solutionTitle: {
      type: String,
      default: ""
    },
    detailId: {
      type: String,
      default: ""
    },
    yunDetailId: {
      type: String,
      default: ""
    },
    // maskPramas: {
    //     type: Object,
    //     default: {}
    // }
  },
  created () {
      // console.log('componentName：' + this.componentName);
      // console.log('solutionTitle：' + this.solutionTitle);
      // console.log('detailId：' + this.detailId);
      // console.log('yunDetailId：' + this.yunDetailId);
      //       let windowMap = {
      //   "cooperationRegister": "13vh",
      //   "complaint": "13vh",
      //   "noDisplay": "27vh",
      //   "solution": "8vh",
      //   "coupon": "15vh",
      //   "yunClass": "20vh"
      // };
      // this.windowTop= windowMap[this.componentName];
  },
  data() {
    return {
      activeComponent: "",
      windowTop: "10vh"
    };
  },
  methods: {
    hide() {
      this.$emit("hide");
    }
  },
};
</script>

<style lang="less">
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  font-family: Source Han Sans CN;
  color: #c0c4cc;
}
input:-moz-placeholder,
textarea::-webkit-input-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-family: Source Han Sans CN;
  color: #c0c4cc;
}
input::-moz-placeholder,
textarea::-webkit-input-placeholder {
  /* Mozilla Firefox 19+ */
  font-family: Source Han Sans CN;
  color: #c0c4cc;
}
input:-ms-input-placeholder,
textarea::-webkit-input-placeholder {
  /* Internet Explorer 10+ */
  font-family: Source Han Sans CN;
  color: #c0c4cc;
}
.el-dialog{
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  /*height:600px;*/
  max-height:calc(100% - 30px);
  max-width:calc(100% - 30px);
}
.el-dialog .el-dialog__body{
  flex:1;
  // overflow: auto;
}

</style>


// WEBPACK FOOTER //
// src/components/page-mask.vue